
import ButtonComp from "./common/ButtonComp"
import PromptDialog from "./PromptDialog";
import { useTranslation } from "react-i18next";
interface paramsType {
    callback: (status?: string) => void
}

const ConfirmPayDialog = ({ callback }: paramsType) => {
    const { t } = useTranslation();
    return (
        <>
            <PromptDialog teleport={document.querySelector('body')} title={t("other.attention")} dialog={true} setDialog={() => {

            }} text='' className="customClassName">
                <div className='flex flex-col items-center'>
                    <p className='text-sm text-[#333] text-center'>{t("components.other.noPaymentReceived")}</p>
                    <p className='text-sm text-[#333] text-center'>{t("components.other.ensurePaymentCompleted")}</p>
                    <ButtonComp mt={20} isOtherColor callBack={() => {
                        callback && callback()
                    }} title={t("components.other.paymentCompleted")}></ButtonComp>
                    <ButtonComp mt={10} title={t("components.other.unpaid")} callBack={() => {
                        callback && callback("close")
                    }}></ButtonComp>
                </div>
            </PromptDialog>
        </>
    )
}


export default ConfirmPayDialog